import { Bet } from "./bet.model";
import { SavePurchase } from "./savepurchase.model";

export class BetDetails {
    constructor(
        public bets: Array<Bet> = new Array<Bet>(),
        public savePurchase: SavePurchase = new SavePurchase(),
        public totalAmount: number = null,
        public totalItem: number = null,
        public gameId: number = null,
        public orderId: number = null,
        public phone: String = '',
        public latitude: String = '',
        public longitude: String = ''
    ){}
}